import React from 'react';

const Footer = () => {
    return (
        <div className='footer-container'>
            <div className='footer-content'>
                <p>Created by</p>
                <p><b>Jennifer Cao, 2025 🛬</b></p>
            </div>
        </div>
    );
}

export default Footer;